import { DELETE } from "../APiHelper/API"


export const deleteMessageFromConversationFixture = (message_id, onSuccess, onError) => {

    DELETE(`/api/v1/conversations/delete_message/${message_id}`, onSuccess, onError)
}